import { Component, OnInit } from '@angular/core';
import { TechnicalserviceService } from '../../../technicalservice/services/technicalservice.service';
import { PurchaseProductService } from '../../../purchase/services/purchase-product.service';
import { RepurchaseProductService } from '../../../repurchase/services/repurchase-product.service';
import { ConsignmentProductService } from '../../../consignment/services/consignment-product.service';
import { ShopService } from '../../../configuration/services/shop.service';

import { Angular2Csv } from 'angular2-csv/Angular2-csv';
import * as moment from 'moment/moment';
import * as _ from 'lodash/lodash';
var Excel =   ' exceljs ' ;

declare let alasql;


@Component({
  selector: 'app-police-report',
  templateUrl: './police-report.component.html',
  styleUrls: ['./police-report.component.css'],
  providers:[TechnicalserviceService, PurchaseProductService,RepurchaseProductService,ConsignmentProductService,ShopService]
})
export class PoliceReportComponent implements OnInit {
    shops: any = [];
    technicalservices: any = [];
    shopSelected: any;
    constructor(private technicalserviceService: TechnicalserviceService, private purchaseProductService:PurchaseProductService, private shopService:ShopService,
                private repurchaseProductService: RepurchaseProductService, private consignmentProductService:ConsignmentProductService) { }

    ngOnInit() {
        this.getShops();
    }
  
    getShops(){
      this.shopService.query({})
        .subscribe((shops) => {
          this.shops = shops;
          this.shopSelected = shops[0];
        });
    }
 
    getTechnicalServices(){
        this.technicalserviceService.query({where:{shop:this.shopSelected.id, internal:0, createdAt: {'>':moment().year()+"-01-01"}}})
                    .subscribe((technicalservices) => {
                        this.technicalservices = technicalservices;
                        var options = {   
                            fieldSeparator: ';',
                            quoteStrings: '"',
                            decimalseparator: '.',
                            showLabels: false,
                            showTitle: false,
                            useBom: false,   
                            bookType:'xlsx' ,  
                            cellStyles:true,
                        };             
                      let report = [
                          
                            {
                                field1:"FECHA ENTRADA",
                                field2:"DESCRIPCIÓN DE LOS OBJETOS:MARCA,MODELO,Nº DE SERIE(MOVILES IMEI)CARACTERISTICAS ESPECIALES.",
                                field3:"NOMBRE Y APELLIDOS  PROPIETARIO",
                                field4:"FECHA DE NACIMIENTO",
                                field5:"DNI, NIE, PASAPORTE",
                                field6:"DIRECCIÓN",
                                field7:"POBLACIÓN",
                                field8:"TELÉFONO CONTACTO",
                                
                            }
                        ]
                        technicalservices.forEach(technicalservice =>{
                            var row = {
                                field1:(technicalservice.date?moment(technicalservice.date).format("DD-MM-YYYY"):""),
                                field2:(technicalservice.product?"Descripción: "+technicalservice.product:"") + " " 
                                    +  (technicalservice.model?"Entra por: "+technicalservice.model:"") + " " 
                                    +  (technicalservice.serial_number?"Número de serie: "+technicalservice.serial_number:"") + " " 
                                    +  (technicalservice.imei?"Imei: "+technicalservice.imei:"") + " "
                                    +  (technicalservice.imei2?"Imei2: "+technicalservice.imei2:"") + " ",
                                field3:(technicalservice.name?technicalservice.name:"") + " " 
                                    +  (technicalservice.surname?technicalservice.surname:"") + " " ,
                                field4:(technicalservice.person.born_date?moment(technicalservice.person.born_date).format("DD-MM-YYYY"):""),
                                field5:technicalservice.nif?technicalservice.nif:"",
                                field6:technicalservice.address?technicalservice.address:"",
                                field7:(technicalservice.town?technicalservice.town:"") +" "
                                    +  (technicalservice.state?technicalservice.state:""),
                                field8:technicalservice.person.telephone?technicalservice.person.telephone:"",
                                
                            }
                            report.push(row);
                          
                        });
                         
                        var mystyle = {   
                            headers:true,       
                            columns:    
                                [{columnid:'field1',width:100,title: ''},   
                                {columnid:'field2',width:500,title: 'LIBRO DE POLICÍA, REPARACIÓN TELEFONÍA '+this.shopSelected.name+'.'},
                                {columnid:'field3',width:220,title: ''},
                                {columnid:'field4',width:100,title: ''},
                                {columnid:'field5',width:100,title: ''},
                                {columnid:'field6',width:200,title: ''},
                                {columnid:'field7',width:200,title: ''},
                                {columnid:'field8',width:100,title: ''}, 
                                
                                ],
                             /*header*/
                           
                            column: {  
                                style:{
                                    Alignment:{
                                        Horizontal:"Center",
                                        Vertical:"Center",  
                                        WrapText:1
                                        
                                    },
                                    Font:{
                                        Bold:"1",
                                        Color:"#000000",
                                        Size:10
                                    },
                                    
                                    Interior:{
                                        Color:"#7CEECE",
                                        Pattern:"Solid"
                                    }
                                }},
                           cells: {    
                                0:{
                                    0:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid",
                                                },
                                        Alignment:{
                                           Horizontal:"Center",
                                           Vertical:"Center",
                                           WrapText: 1,
                                            },  
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                        },                        
                                        }  
                                    },
                                    1:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                    },  
                                        Font:{
                                                Size:10,
                                                Bold:"1",
                                                Color:"#000000",
                                        },            
                                            }
                                    },
                                    2:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                                }, 
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    }                
                                            }
                                        },
                                    3:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1,
                                                },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },            
                                               
                                            }
                                        },
                                    4:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                                },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },                           
                                            }
                                        },
                                    5:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                        },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },                           
                                            }
                                        }, 
                                    6:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                        },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },                             
                                        }
                                        },
                                    7:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1,
                                                },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },              
                                            }
                                        },       
                                }   
                           },
                    };
                     
                        alasql.promise('SELECT * INTO XLSXML("informe_st_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
                        
                        .then(function(data){
                             console.log('Data saved');
                        }).catch(function(err){
                             console.log('Error:', err);
                        });
                    });

    }

    cleanValue(value){
        value = value.replace(/</g, '');
        value = value.replace(/>/g, '');
        value = value.replace(/;/g, '');
        value = value.replace(/[^a-z0-9áéíóúñü \.,_-]/gim,"");
        return value;
    }
    roundValue(value){
        return Math.round(value * 100) / 100;
    }

    getPoliceReport(){
        var report = [];
        this.purchaseProductService.query({where: {createdAt: {'>=':moment().year()+"-01-01"}}}).subscribe((purchaseProducts) =>{
            let groupedPurchaseProducts = _.groupBy(purchaseProducts, (p)=>{return p.purchase.id})
            Object.keys(groupedPurchaseProducts).forEach(key =>{
                let purchaseProductsGroup = groupedPurchaseProducts[key];
                
                if (purchaseProductsGroup[0].purchase && purchaseProductsGroup[0].product && purchaseProductsGroup[0].purchase.shop === this.shopSelected.id){
                    let field4 = "";
                    purchaseProductsGroup.forEach((purchaseProduct)=>{
                    purchaseProduct.product.typeDescription="";
                    purchaseProduct.product.naturalDescription="";
                        if(purchaseProduct.product.type=="1"){
                            if(purchaseProduct.product.sub_type=="1"){
                                purchaseProduct.product.typeDescription += "Tipo:Móvil"
                                }
                            if(purchaseProduct.product.sub_type=="2"){
                            purchaseProduct.product.typeDescription += "Tipo:Tablet"
                            }  
                            }
                        if(purchaseProduct.product.type=="2"){
                           purchaseProduct.product.typeDescription="Tipo:Consolas";
                        }
                        if(purchaseProduct.product.type=="3"){
                           purchaseProduct.product.typeDescription="Cantidad:"+purchaseProduct.product.stock+ " "
                        }
                        if(purchaseProduct.product.type=="4"){
                           if(purchaseProduct.product.sub_type=="1"){
                                purchaseProduct.product.typeDescription += "Tipo:PC";
                                }
                            if(purchaseProduct.product.sub_type=="2"){
                            purchaseProduct.product.typeDescription += "Tipo:Portatil";
                            }
                        }
                        if (purchaseProduct.product.description){
                            if (purchaseProduct.product.type != "3"){
                                purchaseProduct.product.naturalDescription += "Descripción:"+purchaseProduct.product.description+" ";
                            }else{
                                purchaseProduct.product.naturalDescription += "Descripción:"+purchaseProduct.product.description+" ";
                            }            }
                        field4 += this.cleanValue((purchaseProduct.product.typeDescription?purchaseProduct.product.typeDescription:"") + " " 
                                +  (purchaseProduct.product.brand?"Marca: "+purchaseProduct.product.brand:"") + " " 
                                + (purchaseProduct.product.model?"Modelo: "+purchaseProduct.product.model:"") + " " 
                                + (purchaseProduct.product.so?"Sistema Operativo: "+purchaseProduct.product.so:"") + " "    
                                +  (purchaseProduct.product.telephone_company ?"Operador:"+purchaseProduct.product.telephone_company:"") + " "  
                                +  (purchaseProduct.product.status ?"Estado:"+purchaseProduct.product.status:"") + " " 
                                +  (purchaseProduct.product.storage_capacity ?"Capacidad:"+purchaseProduct.product.storage_capacity:"") + " " 
                                +  (purchaseProduct.product.imei?"Imei: "+purchaseProduct.product.imei:"") + " "
                                +  (purchaseProduct.product.imei2?"Imei2: "+purchaseProduct.product.imei2:"") + " "
                                +  (purchaseProduct.product.serial_number ?"Número de serie: "+purchaseProduct.product.serial_number:"") + " " 
                                +  (purchaseProduct.product.cpu ?"Procesador: "+purchaseProduct.product.cpu:"") + " "
                                +  (purchaseProduct.product.ram ?"Memoria Ram: "+purchaseProduct.product.ram:"") + " "
                                +  (purchaseProduct.product.naturalDescription?purchaseProduct.product.naturalDescription:"") + " ");    
                                 
                    })
                    report.push({
                            field1:1,
                            field2:purchaseProductsGroup[0].purchase.date?moment(purchaseProductsGroup[0].purchase.date).format("DD-MM-YYYY"):"",
                            field3:purchaseProductsGroup[0].purchase.total_amount,
                            field4:"Compra " + field4,
                            field5:(purchaseProductsGroup[0].purchase.name?purchaseProductsGroup[0].purchase.name:"") + " " 
                                +  (purchaseProductsGroup[0].purchase.surname?purchaseProductsGroup[0].purchase.surname:"") + " " ,
                            field6:purchaseProductsGroup[0].purchase.born_date?moment(purchaseProductsGroup[0].purchase.born_date).format("DD-MM-YYYY"):"",
                            field7:purchaseProductsGroup[0].purchase.nif?purchaseProductsGroup[0].purchase.nif:"",
                            field8:purchaseProductsGroup[0].purchase.address?purchaseProductsGroup[0].purchase.address:"",
                            field9:purchaseProductsGroup[0].purchase.town?purchaseProductsGroup[0].purchase.town:"",
                            field10:purchaseProductsGroup[0].purchase.state?purchaseProductsGroup[0].purchase.state:"",
                            field11:purchaseProductsGroup[0].purchase.createdAt?moment(purchaseProductsGroup[0].purchase.createdAt).format("DD-MM-YYYY HH:mm"):"",
                    });
                }
            });
            this.repurchaseProductService.query({
                where: {createdAt: {'>=':moment().year()+"-01-01"}}
            }).subscribe((repurchaseProducts) =>{
                let groupedRepurchaseProducts = _.groupBy(repurchaseProducts, (p)=>{return p.repurchase.id})
                Object.keys(groupedRepurchaseProducts).forEach(key =>{
                    let repurchaseProductsGroup = groupedRepurchaseProducts[key];
                    if (repurchaseProductsGroup[0].repurchase && repurchaseProductsGroup[0].product && repurchaseProductsGroup[0].repurchase.shop === this.shopSelected.id){
                        let field4 = "";
                        repurchaseProductsGroup.forEach((repurchaseProduct)=>{
                            repurchaseProduct.product.typeDescription="";
                            repurchaseProduct.product.naturalDescription="";
                        if(repurchaseProduct.product.type=="1"){
                            if(repurchaseProduct.product.sub_type=="1"){
                                repurchaseProduct.product.typeDescription += "Tipo:Móvil"
                            }
                            if(repurchaseProduct.product.sub_type=="2"){
                                repurchaseProduct.product.typeDescription += "Tipo:Tablet"
                            }  
                        }
                        if(repurchaseProduct.product.type=="2"){
                           repurchaseProduct.product.typeDescription="Tipo:Consolas";
                        }
                        if(repurchaseProduct.product.type=="3"){
                           repurchaseProduct.product.typeDescription="Cantidad:"+repurchaseProduct.product.stock+ " "
                        }
                        if(repurchaseProduct.product.type=="4"){
                           if(repurchaseProduct.product.sub_type=="1"){
                                repurchaseProduct.product.typeDescription += "Tipo:PC";
                            }
                            if(repurchaseProduct.product.sub_type=="2"){
                                repurchaseProduct.product.typeDescription += "Tipo:Portatil";
                            }
                        }
                        if (repurchaseProduct.product.description){
                            if (repurchaseProduct.product.type != "3"){
                                repurchaseProduct.product.naturalDescription += "Descripción:"+repurchaseProduct.product.description+" ";
                            }else{
                                repurchaseProduct.product.naturalDescription += "Descripción:"+repurchaseProduct.product.description+" ";
                            }            }
                           
                            field4 += this.cleanValue((repurchaseProduct.product.typeDescription?repurchaseProduct.product.typeDescription:"") + " " 
                                    + (repurchaseProduct.product.brand? "Marca: "+repurchaseProduct.product.brand:"") + " " 
                                    + (repurchaseProduct.product.model? "Modelo: "+repurchaseProduct.product.model:"") + " " 
                                    + (repurchaseProduct.product.so?"Sistema Operativo: "+repurchaseProduct.product.so:"") + " "    
                                    + (repurchaseProduct.product.telephone_company ?"Operador:"+repurchaseProduct.product.telephone_company:"") + " "
                                    + (repurchaseProduct.product.status ?"Estado:"+repurchaseProduct.product.status:"") + " " 
                                    + (repurchaseProduct.product.storage_capacity ?"Capacidad:"+repurchaseProduct.product.storage_capacity:"") + " "    
                                    + (repurchaseProduct.product.imei? "Imei: "+repurchaseProduct.product.imei:"") + " "
                                    + (repurchaseProduct.product.imei2? "Imei2: "+repurchaseProduct.product.imei2:"") + " "
                                    + (repurchaseProduct.product.serial_number? "Número de serie: "+repurchaseProduct.product.serial_number:"") + " "
                                    + (repurchaseProduct.product.cpu ?"Procesador: "+repurchaseProduct.product.cpu:"") + " "
                                    + (repurchaseProduct.product.ram ?"Memoria Ram: "+repurchaseProduct.product.ram:"") + " " 
                                    + (repurchaseProduct.product.naturalDescription?repurchaseProduct.product.naturalDescription:"") + " ");
                                    
                                     
                        })
                        report.push({
                            field1:1,
                            field2:repurchaseProductsGroup[0].repurchase.init_date?moment(repurchaseProductsGroup[0].repurchase.init_date).format("DD-MM-YYYY"):"",
                            field3:repurchaseProductsGroup[0].repurchase.total_purchase_amount,
                            field4:"Recompra " + field4,
                            field5:(repurchaseProductsGroup[0].repurchase.name?repurchaseProductsGroup[0].repurchase.name:"") + " " 
                                  +(repurchaseProductsGroup[0].repurchase.surname?repurchaseProductsGroup[0].repurchase.surname:"") + " " ,
                            field6:repurchaseProductsGroup[0].repurchase.born_date?moment(repurchaseProductsGroup[0].repurchase.born_date).format("DD-MM-YYYY"):"",
                            field7:repurchaseProductsGroup[0].repurchase.nif?repurchaseProductsGroup[0].repurchase.nif:"",
                            field8:repurchaseProductsGroup[0].repurchase.address?repurchaseProductsGroup[0].repurchase.address:"",
                            field9:repurchaseProductsGroup[0].repurchase.town?repurchaseProductsGroup[0].repurchase.town:"",
                            field10:repurchaseProductsGroup[0].repurchase.state?repurchaseProductsGroup[0].repurchase.state:"",
                            field11:repurchaseProductsGroup[0].repurchase.createdAt?moment(repurchaseProductsGroup[0].repurchase.createdAt).format("DD-MM-YYYY HH:mm"):"",
                        });
                    }
                });
                this.consignmentProductService.query({where: {createdAt: {'>=':moment().year()+"-01-01"}}}).subscribe((consignmentProducts) =>{
                    let groupedConsignmentProducts = _.groupBy(consignmentProducts, (p)=>{return p.consignment.id})
                    Object.keys(groupedConsignmentProducts).forEach(key =>{
                        let consignmentProductsGroup = groupedConsignmentProducts[key];
                        if (consignmentProductsGroup[0].consignment && consignmentProductsGroup[0].product && consignmentProductsGroup[0].consignment.shop === this.shopSelected.id){
                            let field4 = "";
                            let field3 = 0;
                            consignmentProductsGroup.forEach((consignmentProduct)=>{
                                consignmentProduct.product.typeDescription="";
                                consignmentProduct.product.naturalDescription="";
                                if(consignmentProduct.product.type=="1"){
                                    if(consignmentProduct.product.sub_type=="1"){
                                        consignmentProduct.product.typeDescription += "Tipo:Móvil"
                                        }
                                    if(consignmentProduct.product.sub_type=="2"){
                                    consignmentProduct.product.typeDescription += "Tipo:Tablet"
                                    }  
                                    }
                                if(consignmentProduct.product.type=="2"){
                                consignmentProduct.product.typeDescription="Tipo:Consolas";
                                }
                                if(consignmentProduct.product.type=="3"){
                                consignmentProduct.product.typeDescription="Cantidad:"+consignmentProduct.product.stock+ " "
                                }
                                if(consignmentProduct.product.type=="4"){
                                if(consignmentProduct.product.sub_type=="1"){
                                        consignmentProduct.product.typeDescription += "Tipo:PC";
                                        }
                                    if(consignmentProduct.product.sub_type=="2"){
                                    consignmentProduct.product.typeDescription += "Tipo:Portatil";
                                    }
                                }
                                if (consignmentProduct.product.description){
                                    consignmentProduct.product.naturalDescription += "Descripción:"+consignmentProduct.product.description+" ";
                                }            
                                field4 += this.cleanValue((consignmentProduct.product.typeDescription?consignmentProduct.product.typeDescription:"") + " "
                                        + (consignmentProduct.product.brand?"Marca: "+consignmentProduct.product.brand:"") + " " 
                                        + (consignmentProduct.product.model?"Modelo: "+consignmentProduct.product.model:"") + " " 
                                        + (consignmentProduct.product.so?"Sistema Operativo: "+consignmentProduct.product.so:"") + " "    
                                        + (consignmentProduct.product.telephone_company ?"Operador:"+consignmentProduct.product.telephone_company:"") + " "
                                        + (consignmentProduct.product.status ?"Estado:"+consignmentProduct.product.status:"") + " " 
                                        + (consignmentProduct.product.storage_capacity ?"Capacidad:"+consignmentProduct.product.storage_capacity:"") + " "        
                                        + (consignmentProduct.product.imei?"Imei: "+consignmentProduct.product.imei:"") + " "
                                        + (consignmentProduct.product.imei2?"Imei2: "+consignmentProduct.product.imei2:"") + " "
                                        + (consignmentProduct.product.serial_number?"Número de serie: "+consignmentProduct.product.serial_number:"") + " " 
                                        + (consignmentProduct.product.cpu ?"Procesador: "+consignmentProduct.product.cpu:"") + " "
                                        + (consignmentProduct.product.ram ?"Memoria Ram: "+consignmentProduct.product.ram:"") + " " 
                                        + (consignmentProduct.product.naturalDescription?consignmentProduct.product.naturalDescription:"") + " ")
                                if (consignmentProduct.product.purchase_price)
                                    field3 += parseFloat(consignmentProduct.product.purchase_price);
                            })
                            report.push({
                                field1:1,
                                field2:consignmentProductsGroup[0].consignment.date?moment(consignmentProductsGroup[0].consignment.date).format("DD-MM-YYYY"):"",
                                field3:""+this.roundValue(field3)+"",
                                field4:"Consigna " + field4,
                                field5:(consignmentProductsGroup[0].consignment.name?consignmentProductsGroup[0].consignment.name:"") + " " +(consignmentProductsGroup[0].consignment.surname?consignmentProductsGroup[0].consignment.surname:"") + " " ,
                                field6:consignmentProductsGroup[0].consignment.born_date?moment(consignmentProductsGroup[0].consignment.born_date).format("DD-MM-YYYY"):"",
                                field7:consignmentProductsGroup[0].consignment.nif?consignmentProductsGroup[0].consignment.nif:"",
                                field8:consignmentProductsGroup[0].consignment.address?consignmentProductsGroup[0].consignment.address:"",
                                field9:consignmentProductsGroup[0].consignment.town?consignmentProductsGroup[0].consignment.town:"",
                                field10:consignmentProductsGroup[0].consignment.state?consignmentProductsGroup[0].consignment.state:"",
                                field11:consignmentProductsGroup[0].consignment.createdAt?moment(consignmentProductsGroup[0].consignment.createdAt).format("DD-MM-YYYY HH:mm"):"",
                            });
                        }
                    });
                    report = _.orderBy(report, (e)=>{return e.field11?parseInt(moment(e.field11,"DD-MM-YYYY HH:mm").format("YYYYMMDDHHmm")):1});
                    report.unshift(
                        {
                            field1:"LOTE Nº",
                            field2:"FECHA DE COMPRA",
                            field3:"PRECIO",
                            field4:"DESCRIPCIÓN DE LOS OBJETOS",
                            field5:"NOMBRE Y APELLIDOS  VENDEDOR",
                            field6:"FECHA DE NACIMIENTO",
                            field7:"DNI, NIE, PASAPORTE",
                            field8:"DIRECCIÓN",
                            field9:"POBLACIÓN",
                            field10:"PROVINCIA",
                        });
                    report.forEach((row,index)=>{
                        if (index > 0){
                            row.field1 = index;
                        }
                    });
                    var mystyle = {
                        headers:true,    
                        columns: [
                                {columnid:'field1',width:50,title: ''},
                                {columnid:'field2',width:50,title: ''},
                                {columnid:'field3',width:80,title: ''},
                                {columnid:'field4',width:400,title: ''},
                                {columnid:'field5',width:200,title: 'LIBRO DE POLICÍA,  OBJETOS  SEGUNDA MANO, '+this.shopSelected.name+'.'},
                                {columnid:'field6',width:80,title: '' },
                                {columnid:'field7',width:80,title: ''},
                                {columnid:'field8',width:80,title: ''},
                                {columnid:'field9',width:150,title: ''},
                                {columnid:'field10',width:150,title: ''},
                                ] ,
                                column: { 
                                    style:{
                                        Alignment:{
                                            Horizontal:"Center",
                                            Vertical:"Center",  
                                            WrapText:1
                                            
                                        },
                                        Font:{
                                            Bold:"1",
                                            Color:"#000000",
                                            Size:12
                                        },
                                        
                                        Interior:{
                                            Color:"#7CEECE",
                                            Pattern:"Solid"
                                        }
                                    }
                            },     
                                cells: {    
                                0:{
                                    0:{style:{
                                        Interior:{ 
                                            Color:"#FFFFFF",
                                            Pattern:"Solid",
                                                },
                                        Alignment:{
                                           Horizontal:"Center",
                                           Vertical:"Center",
                                           WrapText: 1, 
                                           Indent:1
                                            },  
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },                        
                                        }  
                                    },
                                    
                                    1:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                            Indent:1
                                    },
                                    Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },            
                                            }
                                    },
                                    2:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                             Indent:1
                                            },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },                 
                                            }
                                        },
                                    3:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                             Indent:1
                                                },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },                      
                                            }
                                        },
                                    4:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                             Indent:1
                                    },
                                    Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },                   
                                            }
                                        },
                                    5:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                             Indent:1
                                            },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },                           
                                            }
                                        }, 
                                    6:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                             Indent:1
                                            },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },                            
                                            }
                                        },
                                    7:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                             Indent:1
                                            },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },              
                                            }
                                        },      
                                        8:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                             Indent:1
                                            }, 
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },             
                                            }
                                        },
                                        9:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                             Indent:1
                                            },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },              
                                            }
                                        },
                                        10:{style:{
                                        Interior:{ 
                                            Color:"#95a5a6",
                                            Pattern:"Solid"
                                                    },
                                        Alignment:{
                                            Horizontal: 'Center', 
                                            Vertical: 'Center',
                                            WrapText: 1, 
                                             Indent:1
                                            },
                                        Font:{
                                            Size:10,
                                            Bold:"1",
                                            Color:"#000000",
                                    },              
                                            }
                                        }, 
                                }   }         
                      };
                      
                    alasql.promise('SELECT * INTO XLSXML("informe_policial_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
                    .then(function(data){
                         console.log('Data saved');
                    }).catch(function(err){
                         console.log('Error:', err);
                    });
                });
            });
        });
    }



}



// WEBPACK FOOTER //
// ./src/app/reports/components/police-report/police-report.component.ts